webshop.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "Grid View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="col-sm-4 item-card"><div class="card text-left">`;
			html += me.get_image_html(item, title);
			html += me.get_card_body_html(item, title, me.settings);
			html += `</div></div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		this.bind_qty_events();
	}

	bind_qty_events() {
		this.products_section.on("input", ".item-qty-area .item-qty", (event) => {
			let currentValue = event.target.value;
			let validValue = currentValue.replace(/[^0-9]/g, "");
			event.target.value = validValue;
		});

		this.products_section.on("click", ".item-qty-area .up-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(currentValue + step);
		});

		this.products_section.on("click", ".item-qty-area .dwn-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let minQty = parseInt(item_qty.data("min-qty")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(Math.max(currentValue - step, minQty));
		});
	}

	get_image_html(item, title) {
		let image = item.website_image;

		if (image) {
			return `
				<div class="card-img-container">
					<a href="/${ item.route || '#' }" style="text-decoration: none;">
						<img itemprop="image" class="card-img" src="${ image }" alt="${ title }"
							loading="lazy">
					</a>
				</div>
			`;
		} else {
			return `
				<div class="card-img-container">
					<a href="/${ item.route || '#' }" style="text-decoration: none;">
						<div class="card-img-top no-image">
							${ frappe.get_abbr(title) }
						</div>
					</a>
				</div>
			`;
		}
	}

	get_card_body_html(item, title, settings) {
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div style="margin-top: 0.35rem; display: flex;">
		`;
		body_html += this.get_title(item, title);

		// get floating elements
		if (!item.has_variants) {
			if (settings.enable_wishlist) {
				body_html += this.get_wishlist_icon(item);
			}
		}

		body_html += `</div>`;
		body_html += `<div class="product-category" itemprop="name">${ item.item_group_display || item.item_group || '' }</div>`;
		body_html += `<p class="product-code">${ __('Item Code') } : ${ item.item_code || '' }</p>`;

		if (item.formatted_price) {
			body_html += this.get_price_html(item);
		}

		body_html += this.get_stock_availability(item, settings);
		body_html += this.get_cart_action_row(item, settings);
		body_html += `</div>`;

		return body_html;
	}

	get_title(item, title) {
		return `
			<a href="/${ item.route || '#' }" style="text-decoration: none; flex: 1;">
				<div class="product-title" itemprop="name">
					${ title || '' }
				</div>
			</a>
		`;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ item.item_code }">
				<svg class="icon sm">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</div>
		`;
	}

	get_price_html(item) {
		let price_html = `
			<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

		if (item.formatted_mrp) {
			price_html += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}
		price_html += `</div>`;
		return price_html;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<span class="out-of-stock mb-2 mt-1">
						${ __("Out of stock") }
					</span>
				`;
			}
		}
		return ``;
	}

	get_cart_action_row(item, settings) {
		if (item.has_variants) {
			return `
				<div class="mt-3">
					<a href="/${ item.route || '#' }">
						<div class="btn btn-sm btn-explore-variants">
							${ __("Explore") }
						</div>
					</a>
				</div>
			`;
		}

		if (!settings.enabled || (!settings.allow_items_not_in_stock && !item.in_stock)) {
			return ``;
		}

		// Always render the badge container with fixed height to prevent card height changes.
		// Use visibility:hidden (not display:none) so it reserves space when empty.
		let badge_visible = item.in_cart;
		let cart_badge = `
			<div class="cart-indicator-slot">
				<a href="/cart" class="cart-indicator-link" style="${ badge_visible ? '' : 'visibility:hidden;' }">
					<span class="cart-indicator-badge" data-item-code="${ item.item_code }">
						${ badge_visible ? item.in_cart_qty + ' ' + __("in cart") : '&nbsp;' }
					</span>
				</a>
			</div>
		`;

		return `
			<div class="cart-action-row mt-3">
				${ cart_badge }
				<div class="item-qty-area">
					<div class="input-group number-spinner">
						<span class="input-group-prepend d-sm-inline-block">
							<button class="item-qty-btn dwn-qty" data-dir="dwn">
								&ndash;
							</button>
						</span>
						<input class="form-control text-center item-qty"
							value="${ item.min_qty || 1 }"
							min="${ item.min_qty || 1 }"
							step="${ item.lot_size || 1 }"
							data-item-code="${ item.item_code }"
							data-min-qty="${ item.min_qty || 1 }"
							data-lot-size="${ item.lot_size || 1 }">
						<span class="input-group-append d-sm-inline-block">
							<button class="item-qty-btn up-qty" data-dir="up">
								+
							</button>
						</span>
					</div>
				</div>
				<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list"
					data-item-code="${ item.item_code }"
					title="${ settings.enable_checkout ? __("Add to Cart") : __("Add to Quote") }">
					<svg class="icon icon-md">
						<use href="#icon-assets"></use>
					</svg>
				</div>
			</div>
		`;
	}
};
